import { render, staticRenderFns } from "./AttributeConfigurationType.global.vue?vue&type=template&id=56bdf5a5&scoped=true&lang=pug&"
import script from "./AttributeConfigurationType.global.vue?vue&type=script&lang=ts&"
export * from "./AttributeConfigurationType.global.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeConfigurationType.global.vue?vue&type=style&index=0&id=56bdf5a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bdf5a5",
  null
  
)

export default component.exports